/* eslint-disable @typescript-eslint/no-require-imports, import/no-commonjs */

export const favicons = {
  default: {
    light: require('./favicon.png').default,
    dark: require('./favicon-dark.png').default,
  },
  staging: {
    light: require('./favicon-staging.png').default,
    dark: require('./favicon-staging-dark.png').default,
  },
  localhost: {
    light: require('./favicon-local.png').default,
    dark: require('./favicon-local-dark.png').default,
  },
  connected: {
    light: require('./favicon-connected.png').default,
    dark: require('./favicon-connected-dark.png').default,
  },
  disconnected: {
    light: require('./favicon-disconnected.png').default,
    dark: require('./favicon-disconnected-dark.png').default,
  },
} as const;

export type Favicons = typeof favicons;
